import React from 'react'
import { useIntl } from 'react-intl'
import {
    CheckCircleRounded,
    RadioButtonUncheckedRounded,
} from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'
import {
    calculateNumberFromPercentage,
    capitalize,
} from '../../../../../../utils/functions'
import { PurchasedCourseTopicState } from '../../../../../../features/types'
import { SelectedSubjectState } from '../../types'
import { discount, discountPrice, flexCenter, price } from '../../style'

interface Props {
    topic: PurchasedCourseTopicState
    topics: PurchasedCourseTopicState[]
    promotionDiscount: number
    subject: SelectedSubjectState
    index: number
    selected: boolean
    singleTopicPrice: number
    queryParamsExists: boolean
    onTopicClick: (
        topic: PurchasedCourseTopicState,
        subjectId: number,
        topics?: PurchasedCourseTopicState[],
    ) => void
}

const SelectTopicSubject: React.FC<Props> = ({
    topic,
    topics,
    promotionDiscount,
    index,
    subject,
    singleTopicPrice,
    selected,
    queryParamsExists,
    onTopicClick,
}) => {
    const { locale } = useIntl()
    const theme = useTheme()

    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[100]}`,
            borderRadius: '8px',
            mb: 2,
            minWidth: '500px',
            width: '100%',
        },
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: `1px solid ${theme.palette.grey[100]}`,
            cursor: 'pointer',
            p: 2,
            pr: 2,
        },
    }

    const isSelectedTopic = () => {
        // if (!queryParamsExists) {
        //     return subject.isSelected || selected
        // } else {
        //     return subject.selectedTopics.some(
        //         (selectedTopic) =>
        //             selectedTopic.courseTopicId === topic.courseTopicId,
        //     )
        // }
    }

    const topicPrice = promotionDiscount
        ? calculateNumberFromPercentage(singleTopicPrice, promotionDiscount)
        : singleTopicPrice

    return (
        <Box
            sx={styles.container}
            onClick={() => onTopicClick(topic, subject.id, topics)}
        >
            <Box sx={flexCenter}>
                <Box mr={2}>{index + 1}.</Box>
                <Box>{topic[`title${capitalize(locale)}`]}</Box>

                {promotionDiscount > 0 && (
                    <Box sx={discount}>-{promotionDiscount}%</Box>
                )}
            </Box>

            <Box sx={flexCenter}>
                <Box sx={{ mr: 2 }}>
                    {promotionDiscount > 0 && (
                        <span>
                            <span style={price}>{singleTopicPrice} т</span>

                            <span style={{ color: '#9C9DA1' }}> | </span>
                        </span>
                    )}

                    <span style={discountPrice}>{topicPrice}т</span>
                </Box>

                {subject.isSelected || selected ? (
                    <CheckCircleRounded sx={{ color: '#0B1C3F' }} />
                ) : (
                    <RadioButtonUncheckedRounded />
                )}
            </Box>
        </Box>
    )
}

export default SelectTopicSubject
